export = {
  apiUrl: "https://test.api.srv464304.hstgr.cloud",
};
